module.exports = __webpack_public_path__ + "grabbing.5e32.cur";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/grabbing.cur
// module id = ./src/_asset/sources/assets/images/grabbing.cur
// module chunks = main